import React from 'react'
import { Pagination } from 'antd'
import { inject, observer } from 'mobx-react'

const stylePagination = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 20,
  marginBottom: 10,
}

const ProposalSalaryListPagination = props => {
  const { proposalSalaryStore } = props

  const handleChangePagination = (page, size) => {
    proposalSalaryStore.setQueryParams('filterPage', page - 1)
    proposalSalaryStore.setQueryParams('filterSize', size)
  }
  return (
    <div style={stylePagination}>
      <Pagination
        current={proposalSalaryStore.filterPage + 1}
        pageSize={proposalSalaryStore.filterSize}
        total={proposalSalaryStore.proposalSalaryTotal}
        onChange={handleChangePagination}
      />
    </div>
  )
}

ProposalSalaryListPagination.propTypes = {}
export default inject('proposalSalaryStore')(
  observer(ProposalSalaryListPagination)
)
